
import React from 'react';
import { Box, Typography, Grid, List, ListItem, ListItemText, Card } from '@mui/material';
import HtmlContent from '../../components/HtmlContent';
import DoneIcon from '@mui/icons-material/Done';

function InfoGuide({ guide, requirements }) {
    const midpoint = Math.ceil(requirements.length / 2);
    const firstColumn = requirements.slice(0, midpoint);
    const secondColumn = requirements.slice(midpoint);

    return (
        <Box>
            <Card
                sx={{
                    p: 2,
                    border: '1px solid #ddd',
                    boxShadow: 'none',
                    borderRadius: 2,
                    backgroundColor: '#fff', // Clean white background
                }}
            >
                {/* Lab Guide */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                        Guide
                    </Typography>
                    <HtmlContent html={guide} />
                </Box>

                {/* Requirements */}
                <Box sx={{ mb: 4 }}>
                    {/* Title */}
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 'bold',
                            mb: 2,
                            color: '#333',
                            textAlign: 'left', // Left-align the title
                        }}
                    >
                        Requirements
                    </Typography>

                    {/* Two-column grid for the list */}
                    <Grid container spacing={{ xs: 0, sm: 2 }}>
                        {/* First Column */}
                        <Grid item xs={12} sm={6}
                            sx={{
                                m: 0,
                                p: 0,
                            }}>
                            <List sx={{
                                m: 0,
                                p: 0,
                            }}>
                                {firstColumn.map((item, index) => (
                                    <ListItem
                                        key={index}
                                        sx={{
                                            m: 0,
                                            p: 0,
                                            pt: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <DoneIcon sx={{ color: 'primary.main', mr: 2 }} />
                                        <ListItemText primary={item} sx={{ color: '#555' }} />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>

                        {/* Second Column */}
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            sx={{
                                m: 0,
                                p: 0,
                            }}
                        >
                            <List sx={{
                                m: 0,
                                p: 0,
                            }}>
                                {secondColumn.map((item, index) => (
                                    <ListItem
                                        key={index}
                                        sx={{
                                            m: 0,
                                            p: 0,
                                            pt: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <DoneIcon sx={{ color: 'primary.main', mr: 2 }} />
                                        <ListItemText primary={item} sx={{ color: '#555' }} />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                    </Grid>
                </Box>

            </Card>
        </Box >
    );
}

export default InfoGuide;
